var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC1RoofWindowClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 56h-6.28L21.43 22.47 9 32.73v-5.19l12.44-10.26 13.18 11 3.12-3.75L61.8 44.68l-3 3.66L68 56zM25 38h9v20H12V38h13zm-4 4h-5v12h5V42zm9 0h-5v12h5V42z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/C1_Roof_window_close.cd1f4ce2.svg";
export { SvgC1RoofWindowClose as ReactComponent };